import { render, staticRenderFns } from "./TypeGallery.vue?vue&type=template&id=24468b4f"
import script from "./TypeGallery.vue?vue&type=script&lang=js"
export * from "./TypeGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports